import ApplicationOwner from "components/Application/ApplicationOwner"
import { useEffect, useState } from "react"
import { Row } from "reactstrap"

import Application from "services/applications/Application.service"
import EditPlasticDetails from "./EditPlasticDetails"

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

const DetailsPlasticBags = props => {
  const [consumptionItems, setconsumptionItems] = useState([])
  const [importPurchase, setImportPurchase] = useState("")

  useEffect(() => {
    if (props.appDetails.application_consumption_area_items) {
      // console.log("---------------",props.appDetails.auth_plastic_bags)
      // console.log("consumptionItems",props.appDetails.application_consumption_area_items)
      var items = props.appDetails.application_consumption_area_items.map(
        (item, index) => {
          return " " + item.consumption_area_item.name + ", "
        }
      )
      setconsumptionItems(items)
    }

    // set import purchase
    var data = {
      purchase: props.appDetails.auth_plastic_bags.purchase,
      import: props.appDetails.auth_plastic_bags.import,
      import_single: props.appDetails.auth_plastic_bags.import_single,
      purchase_single: props.appDetails.auth_plastic_bags.purchase_single,
    }

    // set import or purchase
    if (data.purchase) {
      setImportPurchase("Purchase and Use Plastic Carry Bags")
    } else if (data.import) {
      setImportPurchase("Import and Use Plastic Carry Bags")
    } else if (data.import_single) {
      setImportPurchase("Import and Use Single-Use Plastics")
    } else if (data.purchase_single) {
      setImportPurchase("Purchase and Use Single-Use Plastics")
    }
  }, [props.appDetails])
  return (
    <>
      {props.appDetails.auth_plastic_bags.company ? (
        <ApplicationOwner
          appDetails={props.appDetails}
          isCompany={props.appDetails.auth_plastic_bags.company_id}
          company={props.appDetails.auth_plastic_bags.company}
        />
      ) : (
        <ApplicationOwner appDetails={props.appDetails} />
      )}
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Plastic Type </td>
              <td>
                {props.appDetails.auth_plastic_bags.plastic_type.name == "Other"
                  ? props.appDetails.auth_plastic_bags.other_plastic_type
                  : props.appDetails.auth_plastic_bags.plastic_type.name}
              </td>
            </tr>

            <tr>
              <td>For Import or Purchase</td>
              <td>{importPurchase}</td>
            </tr>

            {props.appDetails.auth_plastic_bags.origin ? (
              <tr>
                <td>Country of Origin</td>
                <td>{props.appDetails.auth_plastic_bags.origin}</td>
              </tr>
            ) : (
              <tr>
                <td>Local Supplier Company</td>
                <td>
                  {props.appDetails.auth_plastic_bags.local_supplier.name}
                </td>
              </tr>
            )}

            <tr>
              <td>Quantity Measure</td>
              <td>
                {props.appDetails.auth_plastic_bags.quantity_measure.name}
              </td>
            </tr>

            <tr>
              <td>Quantity</td>
              <td>{props.appDetails.auth_plastic_bags.quantity}</td>
            </tr>

            {props.appDetails.auth_plastic_bags.piece_weight != null ? (
              <tr>
                <td>Quantity Per Piece (g)</td>
                <td>{props.appDetails.auth_plastic_bags.piece_weight}</td>
              </tr>
            ) : null}

            <tr>
              <td>Usage</td>
              <td>
                {props.appDetails.auth_plastic_bags.consumption_area.name ==
                "Other"
                  ? props.appDetails.auth_plastic_bags.other_consumption_area
                  : props.appDetails.auth_plastic_bags.consumption_area.name}
              </td>
            </tr>

            <tr>
              <td>Items to be packaged</td>
              <td>{consumptionItems}</td>
            </tr>

            <tr>
              <td>Where the finished product will be sold or used</td>
              <td>{props.appDetails.auth_plastic_bags.plastics_finished_usage}</td>
            </tr>

            <tr>
              <td>Description</td>
              <td>{props.appDetails.auth_plastic_bags.description}</td>
            </tr>
          </tbody>
        </table>

        <h4>Edit Application Details</h4>
        
        <EditPlasticDetails appDetails={props.appDetails} />
      </Row>
    </>
  )
}

export default DetailsPlasticBags
